import React from "react";
import { Typography, Card, Row, Col, Divider, List, Button, Grid
} from "antd";
import { useNavigate } from "react-router-dom"; // For navigation to Product page
import { Carousel } from "antd"; // Import Carousel for sliding animation

const { Title, Paragraph, Text } = Typography;
const { useBreakpoint } = Grid;

const About = () => {
  const navigate = useNavigate(); // Hook for navigation
  const screens = useBreakpoint();

  const handleBrowseClick = () => {
    navigate("/product"); // Navigate to the Product page
  };

  const testimonies = [
    {
      image: "https://media.istockphoto.com/id/1500308602/photo/happy-black-man-mature-or-portrait-in-finance-office-about-us-company-profile-picture-or-ceo.jpg?s=612x612&w=0&k=20&c=3BWt_eT7QaaiGx4zI_K63pnntIp5Cv1qW8Pw-_bSlm8=",
      name: "Jimmy",
      location: "Imara, Nairobi",
      message: "Dollar Furniture transformed my living space with style and affordability!",
    },
    {
      image: "https://thumbnails.yayimages.com/1600/11/4e5/114e5db8.jpg",
      name: "Mary K.",
      location: "Kapsabet",
      message: "High-quality and affordable furniture, perfect for my home!",
    },
    {
      image: "https://c8.alamy.com/comp/2KABB2A/ceo-black-man-and-portrait-at-office-laptop-with-smile-working-on-report-for-marketing-company-professional-corporate-worker-at-workplace-desk-with-2KABB2A.jpg",
      name: "Maxwell",
      location: "Mombasa",
      message: "Great service and stylish furniture at unbeatable prices.",
    },
    {
      image: "https://thumbs.dreamstime.com/b/beautiful-female-african-american-business-woman-ceo-suit-white-background-smiling-cheerful-headshot-portrait-167982741.jpg",
      name: "Rose M.",
      location: "Karen, Nairobi",
      message: "My office looks amazing, thanks to Dollar Furniture!",
    },
    {
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRhxgeElfODIx2PsOe1NvcqMbWMX3NjUXXz7griAVkr3JrtT0njBICxkmoDURImW7oZzdA&usqp=CAU",
      name: "Emmah",
      location: "Thika",
      message: "Exceptional designs and quality—highly recommended!",
    },
  ];

  return (
    <div style={{ backgroundColor: "#f8f9fa", padding: "50px 20px" }}>
      {/* Header Section */}
      <Row justify="center" style={{ textAlign: "center", marginBottom: "40px" }}>
        <Col span={24}>
          <Title
            style={{
              color: "#2b2d42",
              fontSize: "36px",
              fontWeight: "bold",
            }}
          >
            About Us: Dollar Furniture
          </Title>
          <Text style={{ fontSize: "18px", color: "#6c757d" }}>
            Affordable | Stylish | High-Quality
          </Text>
        </Col>
      </Row>

      {/* Introduction Section */}
      <Row justify="center" gutter={[16, 16]} style={{ marginBottom: "40px" }}>
        <Col xs={24} md={12}>
          <img
            src="https://kentyfurnitures.co.ke/wp-content/uploads/2024/07/Kenty-Coffee-Tables-10.jpg"
            alt="Dollar Furniture Mission"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "12px",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
            }}
          />
        </Col>
        <Col xs={24} md={12}>
          <Card
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <Paragraph
              style={{
                fontSize: "16px",
                color: "#495057",
                textAlign: "justify",
                lineHeight: "1.8",
              }}
            >
              <Text
                strong
                style={{ fontSize: "18px", color: "#2b2d42" }}
              >
                Dollar Furniture
              </Text>{" "}
              was founded with a clear mission: to provide affordable,
              high-quality, and stylish furniture that enhances the spaces people
              live and work in. We understand that furniture is not just about
              filling a room; it’s about creating an environment that reflects
              your personality, lifestyle, and needs.
            </Paragraph>
            <Paragraph
              style={{
                fontSize: "16px",
                color: "#495057",
                textAlign: "justify",
                lineHeight: "1.8",
              }}
            >
              Whether you’re furnishing your home, office, or any other space,
              Dollar Furniture offers a broad range of designs that combine
              beauty, comfort, and practicality—without breaking the bank.
            </Paragraph>
            <Paragraph
              style={{
                fontSize: "16px",
                color: "#495057",
                textAlign: "justify",
                lineHeight: "1.8",
              }}
            >
              At Dollar Furniture, we believe in more than just selling
              furniture; we are in the business of transforming spaces and
              enhancing the lives of our customers. With every piece of
              furniture, we aim to help you create a space that is not only
              functional but also reflective of your personal style.
            </Paragraph>
          </Card>
        </Col>
      </Row>

      {/* Goals Section */}
      <Row justify="center" style={{ marginBottom: "40px" }}>
        <Col span={24} style={{ textAlign: "center" }}>
          <Title level={3} style={{ color: "#2b2d42" }}>
            Our Goals
          </Title>
        </Col>
        <Col xs={24} md={20} lg={16}>
          <List
            size="large"
            bordered={false}
            dataSource={[
              "1. Customer Satisfaction: At the heart of everything we do is a commitment to ensuring our customers are happy with their purchases.",
              "2. Affordability: We are passionate about making furniture affordable.",
              "3. Sustainability: We aim to integrate sustainable practices throughout our business.",
              "4. Innovation: Constantly evolving our product offerings to reflect the latest designs.",
              "5. Community Engagement: Supporting artisans and contributing to community development.",
            ]}
            renderItem={(item) => (
              <List.Item
                style={{ padding: "15px 0", color: "#495057", fontSize: "15px" }}
              >
                {item}
              </List.Item>
            )}
          />
        </Col>
      </Row>

      {/* Values Section */}
      <Row justify="center" gutter={[16, 16]} style={{ marginBottom: "40px" }}>
        <Col xs={24} md={12}>
          <img
            src="https://www.thespruce.com/thmb/a3_MMOuBNHnRRZNjxZ8MPopc5Zc=/2000x0/filters:no_upscale():max_bytes(150000):strip_icc()/Kalu_4144_Trinity_St_Web-151-df23484eb3b948db838e42f36a146173.jpg"
            alt="Our Values"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "12px",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
            }}
          />
        </Col>
        <Col xs={24} md={12}>
          <Title level={3} style={{ color: "#2b2d42", marginBottom: "20px" }}>
            Our Values
          </Title>
          <List
            size="large"
            bordered={false}
            dataSource={[
              "1. Quality: We never compromise on quality.",
              "2. Integrity: Conducting business with honesty and respect.",
              "3. Customer-Centric: Listening to our customers and providing expert advice.",
            ]}
            renderItem={(item) => (
              <List.Item
                style={{ padding: "15px 0", color: "#495057", fontSize: "15px" }}
              >
                {item}
              </List.Item>
            )}
          />
        </Col>
      </Row>


      <Row justify="center" style={{ marginBottom: "40px" }}>
  <Col span={24}>
    <Title level={3} style={{ textAlign: "center", color: "#2b2d42" }}>
      What Our Customers Say
    </Title>
  </Col>
  <Col span={24}>
    {screens.md ? (
      // Horizontal scrollable row for larger screens
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: "16px",
          padding: "10px",
          scrollbarWidth: "thin",
          scrollBehavior: "smooth",
        }}
      >
        {testimonies.map((testimony, index) => (
          <Card
            key={index}
            style={{
              minWidth: "300px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
              padding: "20px",
              flex: "0 0 auto",
            }}
          >
            <img
              src={testimony.image}
              alt={testimony.name}
              style={{
                borderRadius: "50%",
                width: "100px",
                height: "100px",
                marginBottom: "20px",
              }}
            />
            <Text style={{ fontSize: "16px", fontWeight: "bold", display: "block" }}>
              {testimony.name}
            </Text>
            <Text style={{ fontSize: "14px", color: "#6c757d", display: "block" }}>
              {testimony.location}
            </Text>
            <Paragraph style={{ fontSize: "14px", color: "#495057" }}>
              {testimony.message}
            </Paragraph>
          </Card>
        ))}
      </div>
    ) : (
      // Carousel for smaller screens
      <Carousel autoplay autoplaySpeed={5000} effect="scrollx">
        {testimonies.map((testimony, index) => (
          <div key={index}>
            <Row justify="center">
              <Card
                style={{
                  width: 300,
                  margin: "0 auto",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                <img
                  src={testimony.image}
                  alt={testimony.name}
                  style={{
                    borderRadius: "50%",
                    width: "100px",
                    height: "100px",
                    marginBottom: "20px",
                  }}
                />
                <Text style={{ fontSize: "16px", fontWeight: "bold", display: "block" }}>
                  {testimony.name}
                </Text>
                <Text style={{ fontSize: "14px", color: "#6c757d", display: "block" }}>
                  {testimony.location}
                </Text>
                <Paragraph style={{ fontSize: "14px", color: "#495057" }}>
                  {testimony.message}
                </Paragraph>
              </Card>
            </Row>
          </div>
        ))}
      </Carousel>
    )}
  </Col>
</Row>



      {/* Call to Action */}
      <Row justify="center" style={{ marginTop: "50px", textAlign: "center" }}>
        <Col span={24}>
          <Title level={4} style={{ color: "#2b2d42" }}>
            Let Us Help You Transform Your Space
          </Title>
          <Paragraph style={{ fontSize: "16px", color: "#6c757d" }}>
            Explore our collections and find furniture that blends style, comfort,
            and affordability. We’re excited to be a part of your journey.
          </Paragraph>
          <Button
            type="primary"
            size="large"
            style={{
              backgroundColor: "#2b2d42",
              borderColor: "#2b2d42",
              marginTop: "20px",
            }}
            onClick={handleBrowseClick}
          >
            Browse Collections
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default About;
